import React from "react";
import styled from "styled-components";
import { Spinner } from "react-bootstrap";
import {
	Box,
	Typography,
	IconButton,
	useTheme,
	Divider,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Backdrop,
	CircularProgress,
	Tooltip
} from "@material-ui/core";
import {makeStyles} from '@material-ui/core/styles';
//
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import API from "../../network/dashboardAPI";
import {MapSharp} from "@material-ui/icons";

const CardWrapper = styled(Box)`
    border: 2px solid ${({active, theme}) =>
            active ? "#629407" : "#e0e0e0"};
    border-radius: 1px;
    padding: 16px;
    margin-bottom: 16px;
    background-color: ${({active}) => (active ? "#f9fff4" : "#ffffff")};
    box-shadow: ${({active}) =>
            active ? "#b5fa3e" : "0 2px 8px rgba(0,0,0,0.04)"};
    transition: all 0.3s ease;
    cursor: pointer;
    width: 100%;
    position: relative;

    &:hover {
        box-shadow: 0 0 0 2px rgba(156, 197, 75, 0.2);
    }
`;

const AddressTitle = styled(Typography)`
    font-weight: 600;
    font-size: 1rem;
    color: #333;
`;

const AddressContent = styled(Typography)`
    font-size: 0.95rem;
    color: #555;
    margin-top: 4px;
    word-break: break-word;
`;

const CardActions = styled(Box)`
    position: absolute;
    top: 12px;
    right: 12px;
    display: flex;
    gap: 8px;
`;


const useStyles = makeStyles((theme) => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff',
	},
}));
const AdminRadioCard = ({
	                        index,
	                        id,
	                        name,
	                        title,
	                        content,
	                        onEdit,
	                        isUpdatePrimaryAddressReqeust,
	                        indexPrimaryAddr,
	                        handleOpenMap,
	                        disabled,
	                        checked,
	                        onChange,
	                        firstName,
	                        lastName,
	                        value,
	                        house_number,
	                        apartment_name,
	                        street_details,
	                        mobile_number,
	                        city,
	                        landmark,
	                        pin_code,
	                        delivery_instructions,
	                        country_code,
	                        modal,
	                        handleToggle,
	                        setListAddress
                        }) => {
	const theme = useTheme();
	const [deleteAddressModal, setDeleteAddressModal] = React.useState(false);
	const classes = useStyles();
	const [isDeleting, setIsDeleting] = React.useState(false);
	const handleDeleteAddress = async () => {
		try {
			// Optional: set loading state
			setIsDeleting(true);

			const response = await API.DeleteAddress(id).then((res) => res.json());

			if (response.success) {
				setListAddress(response.data.allAddress)
				setDeleteAddressModal(false);
			} else {
				console.error("Delete failed:", response.message);
				alert(response.message || "Failed to delete address");
			}
		} catch (error) {
			console.error("Delete error:", error);
			alert(error.message || "Failed to delete address");
		} finally {
			setIsDeleting(false);
		}
	};

	return (
		<CardWrapper
			component="label"
			htmlFor={`${name}-${id}`}
			active={checked ? 1 : 0}
		>
			<input
				type="radio"
				id={`${name}-${id}`}
				name={name}
				value={value}
				checked={checked}
				disabled={disabled}
				onChange={onChange}
				style={{display: "none"}}
			/>

			<Box display="flex" justifyContent="space-between" alignItems="center">
				<AddressTitle>{title}</AddressTitle>
			</Box>

			<Divider style={{margin: "8px 0 12px"}}/>

			<Box mt={1} onClick={handleOpenMap} role="button" style={{cursor: "pointer"}}>
				<AddressContent>
					{[house_number, apartment_name].filter(Boolean).join(", ")}
				</AddressContent>
				<AddressContent>{street_details}</AddressContent>
				<AddressContent>{content}</AddressContent>
				<AddressContent>
					{[city, landmark, pin_code].filter(Boolean).join(", ")}
				</AddressContent>
			</Box>

			{delivery_instructions && (
				<AddressContent style={{marginTop: 8}}>
					<strong>Instructions:</strong> {delivery_instructions}
				</AddressContent>
			)}

			{/* Actions */}
			<CardActions>
				{!checked ? (
					<>
						{isUpdatePrimaryAddressReqeust && index === indexPrimaryAddr ? (
							<Spinner animation="border" size="sm"/>
						) : (
							<Tooltip title="Set this as your primary address" arrow>
								<Box
									onClick={onEdit}
									style={{
										background: theme.palette.primary.main,
										color: "#fff",
										padding: "4px 12px",
										borderRadius: 20,
										cursor: "pointer",
										fontWeight: 500,
										fontSize: "0.75rem",
										transition: "all 0.2s ease",
									}}
									onMouseOver={(e) => (e.target.style.opacity = 0.9)}
									onMouseOut={(e) => (e.target.style.opacity = 1)}
								>
									Set as Primary
								</Box>
							</Tooltip>
						)}
					</>
				) : (
					<Box
						style={{
							background: "#e8f5e9",
							color: theme.palette.success.dark,
							padding: "4px 10px",
							borderRadius: 20,
							fontWeight: 500,
							fontSize: "0.75rem",
						}}
					>
						Primary
					</Box>
				)}

				<Tooltip title="View on Map" arrow>
					<IconButton
						size="small"
						onClick={handleOpenMap}
						style={{
							marginLeft: 4,
							backgroundColor: "#f5f5f5",
							transition: "0.2s",
						}}
					>
						<MapSharp
							fontSize="small"
							style={{color: theme.palette.info.main}}
						/>
					</IconButton>
				</Tooltip>

				<Tooltip title="Edit Address" arrow>
					<IconButton
						size="small"
						onClick={handleToggle}
						style={{
							marginLeft: 4,
							backgroundColor: "#f5f5f5",
							transition: "0.2s",
						}}
					>
						<EditIcon
							fontSize="small"
							style={{color: theme.palette.info.main}}
						/>
					</IconButton>
				</Tooltip>

				<Tooltip title="Delete Address" arrow>
					<IconButton
						size="small"
						onClick={() => setDeleteAddressModal(true)}
						style={{
							marginLeft: 4,
							transition: "0.2s",
						}}
					>
						<DeleteIcon
							fontSize="small"
							style={{color: theme.palette.error.main}}
						/>
					</IconButton>
				</Tooltip>
			</CardActions>
			<Backdrop className={classes.backdrop} open={isDeleting}>
				<CircularProgress color="inherit"/>
			</Backdrop>
			<Dialog
				open={deleteAddressModal}
				onClose={() => setDeleteAddressModal(false)}
				maxWidth="xs"
				fullWidth
			>
				<DialogTitle>Confirm Deletion</DialogTitle>
				<DialogContent>
					<Typography>
						Are you sure you want to delete this delivery address?
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setDeleteAddressModal(false)} color="default">
						Cancel
					</Button>
					<Button onClick={handleDeleteAddress} color="secondary" variant="contained">
						Delete
					</Button>
				</DialogActions>
			</Dialog>
		</CardWrapper>
	);
};

AdminRadioCard.defaultProps = {
	title: "",
	content: "",
};

export default AdminRadioCard;
